import classNames from "classnames";
import { SkillsList } from "PFApp/components/skills_list";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { InfoSection } from "../../components/info_section";
import { useEssentialSkills } from "../../hooks/use_essential_skills";
import { useSupportingSkills } from "../../hooks/use_supporting_skills";
import { useMatchCardContext } from "../../match_card_context";
import css from "./match_activity_skills.module.scss";

type MatchActivitySkillsProps = {
  className?: string;
};

export const MatchActivitySkills = ({ className }: MatchActivitySkillsProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.matches.card" });
  const { id: profileId, animate } = useMatchCardContext();
  const { matchEssentialSkills, roleEssentialSkills, missingMatchEssentialSkills } = useEssentialSkills();
  const { matchSupportingSkills, roleSupportingSkills, missingMatchSupportingSkills } = useSupportingSkills();

  return (
    <div className={classNames(css.skillsContainer, className)}>
      {!!roleEssentialSkills.length && (
        <InfoSection
          title={
            <Trans
              t={t}
              i18nKey="essentialSkillsCount"
              values={{
                count: matchEssentialSkills.length,
                total: roleEssentialSkills.length
              }}
              components={[<strong key="0" />]}
            />
          }
        >
          <SkillsList
            availableSkills={matchEssentialSkills}
            missingSkills={missingMatchEssentialSkills}
            profileId={profileId}
            onMoreLessButtonClick={animate}
          />
        </InfoSection>
      )}
      {!!roleSupportingSkills.length && (
        <InfoSection
          title={
            <Trans
              t={t}
              i18nKey="supportingSkillsCount"
              values={{
                count: matchSupportingSkills.length,
                total: roleSupportingSkills.length
              }}
              components={[<strong key="0" />]}
            />
          }
        >
          <SkillsList
            availableSkills={matchSupportingSkills}
            missingSkills={missingMatchSupportingSkills}
            profileId={profileId}
            onMoreLessButtonClick={animate}
          />
        </InfoSection>
      )}
    </div>
  );
};
